import { render } from "./OurVision.vue?vue&type=template&id=a879c850&ts=true"
import script from "./OurVision.vue?vue&type=script&lang=ts"
export * from "./OurVision.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__